import {ClinicianSpecialty} from '@domain/specialty/clinician-specialty';
import {User} from '@domain/user';

export class Clinician extends User
{
    public readonly doctorNumber: string;
    
    public readonly specialties: ClinicianSpecialty[];
    
    public readonly description?: string;

    public constructor(
        id: string,
        email: string,
        doctorNumber: string,
        specialties: ClinicianSpecialty[],
        firstName?: string,
        lastName?: string,
        picture?: string,
        description?: string
    )
    {
        super(id, email, firstName, lastName, picture);

        this.doctorNumber = doctorNumber;
        this.specialties = specialties;
        this.description = description;
    }

    public static fromJSON(clinicianJSON: any): Clinician
    {
        return new Clinician(
            clinicianJSON.id,
            clinicianJSON.email,
            clinicianJSON.doctorNumber,
            clinicianJSON.specialities.map(ClinicianSpecialty.fromJSON),
            clinicianJSON.firstName,
            clinicianJSON.lastName,
            clinicianJSON?.picture ?? 'assets/images/avatar_placeholder.webp',
            clinicianJSON.description
        );
    }
}
